import { gql } from '@apollo/client';

export const AUDIT_SESSION_FILTER_OPTIONS_QUERY = gql`
  query AuditSessionFilterOptions($communityId: ID!) {
    auditSessionFilterOptions(communityId: $communityId) {
      standardLabels {
        id
        labelName
        labelShortName
        labelNumMap
      }
      topics
      languages
      severityLevels
      contentTypes
    }
  }
`;
